// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_4m-7";
export var adjustableWidthBorderHeld = "_4m-8";
export var arrow = "_4m-3";
export var arrowButton = "_4m-4";
export var headerCell = "_4m-0";
export var help = "_4m-2";
export var icon = "_4m-1";
export var iconWrapper = "_4m-6";
export var noBorder = "_4m-b";
export var nonAdjustableWidthBorder = "_4m-9";
export var nonAdjustableWidthBorderHeld = "_4m-a";
export var textButton = "_4m-5";